import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { MediaLimitsIndicationView } from '@app/modules/social-export/lib/format-media-limits-indication';
import { Box, MenuItem, Tooltip } from '@mui/material';
import { MediaLimitsIcon } from '../media-limits/MediaLimitsIcon';

type PublishPlatformMenuItemProps = {
  platform: SocialPlatform;
  /** Media-limits indication when the clip has a quality/duration constraint for this platform. */
  indication?: MediaLimitsIndicationView;
  onSelect: (platformId: string) => void;
};

/**
 * Single platform entry in the publish menu; blocked indications disable the item.
 */
export function PublishPlatformMenuItem({
  platform,
  indication,
  onSelect,
}: PublishPlatformMenuItemProps) {
  const isBlocked = Boolean(indication?.blocksPublish);

  const menuItem = (
    <MenuItem disabled={isBlocked} onClick={() => onSelect(platform.id)}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          gap: 1,
        }}
      >
        {platform.Icon({ sx: { fontSize: 20 }, colored: true })}
        <Box sx={{ flexGrow: 1 }}>{platform.name}</Box>
        {indication ? <MediaLimitsIcon kind={indication.kind} /> : null}
      </Box>
    </MenuItem>
  );

  if (!indication) {
    return menuItem;
  }

  // Span wrapper so the tooltip receives hover even when the MenuItem is disabled.
  return (
    <Tooltip title={indication.message} placement="right">
      <Box component="span" sx={{ display: 'block' }}>
        {menuItem}
      </Box>
    </Tooltip>
  );
}
